import { useState } from "react";

const navLinks = [
  { href: "#hot", label: "今日热帖" },
  { href: "#category", label: "热门栏目" },
  { href: "#feature", label: "深读话题" },
  { href: "#rule", label: "吃瓜守则" },
  { href: "#about", label: "关于我们" },
];

export default function Navbar() {
  const [open, setOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 w-full border-b border-background-200/80 bg-background-50/85 backdrop-blur-md">
      <div className="mx-auto flex h-16 items-center justify-between px-4 md:px-8">
        <a href="#top" className="flex items-center gap-2.5" onClick={() => setOpen(false)}>
          <span className="flex h-9 w-9 items-center justify-center rounded-xl bg-primary-500 text-lg text-background-50">
            <i className="ri-water-flash-line" aria-hidden="true" />
          </span>
          <span className="font-heading text-xl font-medium tracking-wide text-foreground-950">
            校园吃瓜网
          </span>
        </a>

        <nav className="hidden items-center gap-7 md:flex" aria-label="主导航">
          {navLinks.map((link) => (
            <a
              key={link.href}
              href={link.href}
              className="whitespace-nowrap text-sm text-foreground-700 transition-colors hover:text-primary-600"
            >
              {link.label}
            </a>
          ))}
        </nav>

        <div className="flex items-center gap-3">
          <a
            href="#submit"
            className="hidden whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50 transition-colors hover:bg-primary-600 sm:inline-flex"
          >
            我要投稿
          </a>
          <button
            type="button"
            aria-label={open ? "关闭菜单" : "打开菜单"}
            onClick={() => setOpen((v) => !v)}
            className="flex h-10 w-10 items-center justify-center rounded-lg border border-background-200 text-xl text-foreground-800 md:hidden"
          >
            <i className={open ? "ri-close-line" : "ri-menu-line"} aria-hidden="true" />
          </button>
        </div>
      </div>

      {open && (
        <nav
          className="border-t border-background-200 bg-background-50 px-6 py-4 md:hidden"
          aria-label="移动端导航"
        >
          <div className="flex flex-col gap-1">
            {navLinks.map((link) => (
              <a
                key={link.href}
                href={link.href}
                onClick={() => setOpen(false)}
                className="rounded-lg px-3 py-2.5 text-sm text-foreground-800 hover:bg-secondary-100"
              >
                {link.label}
              </a>
            ))}
            <a
              href="#submit"
              onClick={() => setOpen(false)}
              className="mt-2 inline-flex justify-center whitespace-nowrap rounded-full bg-primary-500 px-5 py-2.5 text-sm font-medium text-background-50"
            >
              我要投稿
            </a>
          </div>
        </nav>
      )}
    </header>
  );
}